<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="addQuoteRequestModal" ref="modalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId"
         aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Zmiana dostawcy</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
		  <div class="row mb-5" style="color:red;"><center><b>Uwaga! zmiana dostawcy spowoduje anulowanie obecnego zamówienia i utworzenie nowego zamówienia!</b></center></div>
            <div v-if="form && isReady" class="container-fluid">
              <div class="row">

                <div class="col-md-5">
                  <label for="dueDate">Ostateczny termin dostawy:</label>
                  <div class="mb-4" style="max-width: 300px;">
                    <ejs-datepicker
                        id="projectFileProgressId"
                        placeholder="Wybierz zakres dat"
                        :value="form.dueDate"
                        :format="dueDateFormat"
                        :weekNumber="true"
                        @change="changeDeliveryDate"
                    ></ejs-datepicker>
                  </div>
                </div>

                <div class="col-md-7">
                  <label for="emails">
                    Wyślij zamówienie na poniższe maile:
                    <a class="btn btn-xs btn-primary" :href="route('customers.create')" target="_blank">Utwórz
                      klienta</a>
                    <button type="button" class="btn btn-xs btn-outline-primary ms-2" @click="getSuppliersEmails()">
                      Odśwież listę
                    </button>
                  </label>
                  <div v-if="hasError(`emails`)" class="text-danger small">
                    {{ getErrorMessage(`emails`) }}
                  </div>

                  <table class="table">
                    <tbody>
                    <tr v-for="(email, key) in form.emails" :key="key">

                      <td>
                        <TagSelect :endpoint="route('customers.get-customers-with-contacts')"
                                   label="Mail Dostawcy"
                                   label-key="label"
                                   value-key="value"
                                   name="emailsTo[]"
                                   v-model="form.emails[key].to"
								   	@selected="setEmailCustomer(key, $event)"
                                   :max="1"
                        />
                      </td></tr>
                    <tr v-for="(email, key) in form.emails" :key="key">
                      <td>
                        <TagSelect :endpoint="route('customers.get-customers-with-contacts')"
                                   label="Maile DW"
                                   label-key="label"
                                   value-key="value"
                                   name="emailsDw[]"
                                   v-model="form.emails[key].dw"
								   multiple
								   
                        />
<input
  type="text"
  class="form-control form-control-sm mt-1"
  placeholder="Wpisz e-mail i Enter"
  @keydown.enter.prevent="addManualDwEmail(key, $event)"
/>

<div class="mt-1">
  <span
    v-for="(mail, i) in safeDw(form.emails[key].dw)"
    :key="i"
    class="badge bg-secondary me-1"
    style="cursor:pointer"
    @click="removeDwEmail(key, i)"
  >
    {{ mail }} ✕
  </span>
</div>
                      </td>
                    </tr>
                    </tbody>
                  </table>

                </div>
              </div>

              <div class="row">
                <div class="col-md-12 mb-2">
                  <Vueform>
                    <TextElement name="comments"  :default="form.comment" @change="changeComment($event)" autocomplete="off"
                                 label="Komentarz do zamówienia"
                                 placeholder="Komentarz będzie widoczny dla dostawcy po wysłaniu"/>

                  </Vueform>
                </div>
              </div>

              <div class="row mb-3">

                <div class="col-md-4">
                  <label>Forma płatności</label>
                  <select class="form-select form-select-sm" v-model="form.payment_id">
                    <option v-for="method in paymentMethods" :value="method.id">{{ method.name }}</option>
                  </select>
                </div>

                <div class="col-md-4">
                  <label>Rabat globalny (%)</label>
                  <input type="number" class="form-control form-control-sm"
                         v-model.number="globalRabate"
                         min="0" step="0.1"
                         @input="applyGlobalRabate">
                </div>

                <div class="col-md-4">
                  <label>Waluta globalna</label>
<select
    class="form-select form-select-sm"
    v-model="globalCurrency"
    @change="applyGlobalCurrency"
>
    <option
        v-for="currency in currencys"
        :key="currency.id"
        :value="currency.name"
    >
        {{ currency.name }}
    </option>
</select>
                </div>

                <div class="col-md-6">
                  <label>Adres dostawy</label>
                  <select class="form-select form-select-sm" v-model="form.order_where">
                    <option v-for="where in order_where_list" :value="where.id">{{ where.nazwa }} - {{ where.adres_1 }}</option>
                  </select>
                </div>
				
              </div>

              <template v-for="(article, idx) in form.articles" :key="article.id">
                <template v-if="!article.article_id">
                  Brak artykułu. Nie można stworzyć zamówienia.
                </template>
                <template v-else>
                  <table class="table order-list-table">
                    <tbody>
                    <tr>
                      <td colspan="2" class="position-relative">
                        <span>#{{ idx + 1 }}</span>
                        <button type="button"
                                class="btn btn-sm btn-outline-danger position-absolute end-0 top-50 translate-middle-y me-1"
                                title="Usuń artykuł"
                                @click="removeArticle(idx)">
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Do zapytania ofertowego</td>
                      <td>{{ article.quote_request?.request_number || '' }}</td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Nr katalogowy</td>
                      <td>{{ article.catalog_number }}</td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Model</td>
                      <td>{{ article.model }}</td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Ilość zamawiana
                        <i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top"
                           data-bs-html="true"
                           title="Całkowita ilość. Powinna być pomniejszona o zarezerwowane sztuki."></i>
                      </td>
                      <td>
                        <div v-if="hasError(`articles.${idx}.quantity_required`)" class="text-danger small">
                          {{ getErrorMessage(`articles.${idx}.quantity_required`) }}
                        </div>
                        <input class="form-control form-control-sm" type="number" step="0.1" min="0"
                               v-model="article.quantity_required" required>
                      </td>
                    </tr>
                    <tr v-if="context !== 'from_required_project'">
                      <td class="widthFirstTd">
                        Zarezerwowane <i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top"
                                         data-bs-html="true"
                                         title="Zarezerwowana ilość pomniejszona o sztuki, które już trafiły na magazyn projektowy"></i>
                      </td>
                      <td v-if="reservations[`${article.article_id}-${article.required_project_item_id}`]">
                      <span
                          v-if="reservations[`${article.article_id}-${article.required_project_item_id}`].currentlyReserved > 0"
                          :class="reservations[`${article.article_id}-${article.required_project_item_id}`].reservationStatus === 'zatwierdzone'
                          ? 'reservation-approved'
                          : 'reservation-notapproved'"
                      >
                        {{
                          reservations[`${article.article_id}-${article.required_project_item_id}`].currentlyReserved
                        }} -
                        {{
                          reservations[`${article.article_id}-${article.required_project_item_id}`].reservationStatus
                        }}
                      </span>
                        <span v-else>Brak rezerwacji</span>
                      </td>

                      <td v-else>
                        <span>Ładowanie...</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Ostateczny termin dostawy</td>
                      <td>
                        <div v-if="hasError(`articles.${idx}.delivery_date_deadline`)" class="text-danger small">
                          {{ getErrorMessage(`articles.${idx}.delivery_date_deadline`) }}
                        </div>
                        <input class="form-control form-control-sm" type="date"
                               v-model="article.delivery_date_deadline" required>
                      </td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Producent</td>
                      <td>
                        <template v-if="article.producer_short_name">
                          <span class="font-weight-bolder">{{ article.producer_short_name }}</span>
                        </template>
                        <template v-else>
                          <i>Brak domyślnego producenta</i>
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Cena netto
                        <i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="right"
                           data-bs-html="true"
                           title="Domyślnie w zł">
                        </i>
                      </td>
                      <td>
                        <input type="number" class="form-control form-control-sm" min="0" step="0.01"
                               v-model="article.price_netto">
                      </td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Rabat (%)</td>
                      <td class="d-flex align-items-center">
                        <input type="number" class="form-control form-control-sm"
                               v-model="article.rabate">
                        <div class="ms-2 text-nowrap">Kwota rabatu:
                          {{ (article.price_netto * article.quantity_required) * (article.rabate / 100) }}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">VAT</td>
                      <td>
                        <input type="number" class="form-control form-control-sm"
                               v-model="article.vat">
                      </td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Waluta</td>
                      <td>
<select
    class="form-select form-select-sm"
    v-model="article.currency"
>
    <option
        v-for="currency in currencys"
        :key="currency.id"
        :value="currency.name"
    >
        {{ currency.name }}
    </option>
</select>

                      </td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Wartość netto</td>
                      <td>
                        <input type="number" class="form-control form-control-sm" disabled min="0" step="0.01"
                               :value="Number(((article.price_netto * article.quantity_required) * (1 - (article.rabate / 100))).toFixed(2))">
                      </td>
                    </tr>
<tr>
  <td class="widthFirstTd">Uwagi do pozycji</td>
  <td>
    <input
      type="text"
      class="form-control form-control-sm"
      v-model="article.comments"
    />
  </td>
</tr>			
					
					
					
                    </tbody>
                  </table>
                </template>

              </template>
            </div>
          </div>
<div class="border-top pt-3 mt-3 me-5 d-flex justify-content-end">
  <div class="fw-bold fs-5">
    Podsumowanie netto:
    {{ getTotalNetto().toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
  </div>
</div>	  
		  
		  
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              <i class="bi bi-x-square me-2"></i>Zamknij
            </button>
            <form @submit.prevent="saveOrder">
              <button type="submit" class="btn btn-primary" :disabled="form.processing || emailsOk">
                <i class="bi bi-save me-2"></i>Utwórz zamówienie
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {Modal, Tooltip} from "bootstrap";
import {useForm} from "@inertiajs/vue3";
import {DatePickerComponent} from "@syncfusion/ej2-vue-calendars";
import TagSelect from "../RequiredProjectItems/TagSelect.vue";

export default {
  components: {TagSelect, 'ejs-datepicker': DatePickerComponent},
  props: {
    project: Number | String,
    team: String,
	 currencys: {
    type: Array,
    default: () => []
  },
	order_where_list: Array,
    selectedItems: {
      type: Object,
      default: () => {
      }
    },
	  orderComment: {
        type: String,
        default: ''
    },
    context: String
  },

  beforeMount() {
    this.getSuppliersEmails();
    this.getPaymentMethods();
  },

  data() {
    return {
      errors: {},
     isReady: false,
      emailsOk: false,
      quoteRequestNumbers: {},
      suppliersList: {},
      paymentMethods: {},
      modalObj: null,
      reservations: {},
      dueDateFormat: 'dd.MM.yyyy',
      suppliersEmails: [],
      globalRabate: 0,      // globalny rabat %
      globalCurrency: null,
      form: useForm({
	  	order_where: 1,
        dueDate: this.defaultDueDate(),
        payment_id: 1,
        comment: this.orderComment,
        emails: [],
        articles: {}
      })
    }
  },

watch: {
  'form.emails': {
    deep: true,
    handler(val) {
      if (!Array.isArray(val)) return

      val.forEach(e => {
        if (!e) return

        if (!Array.isArray(e.dw)) {
          e.dw = e.dw ? [e.dw] : []
        }
      })
    }
  },

  selectedItems: {
    immediate: true,
    handler(newItems) {
      this.isReady = false
      if (!newItems) return
      this.form = useForm({
        order_where: this.form.order_where || 1,
        dueDate: this.defaultDueDate(),
        comment: this.orderComment,
        emails: this.prepareSuppliersEmails(newItems),
        payment_id: this.form.payment_id || 1,
		articles: newItems .filter(article => article.project_id ?? article.quote_request?.project_id) .map((article) => {
		const quoteRequest = article.quote_request ? {
        id: article.quote_request.id,
        comment: article.quote_request.comment,
        due_date: article.quote_request.due_date,
        project_id: article.quote_request.project_id,
        request_number: article.quote_request.request_number,
        team_name: article.quote_request.team_name,
		
		} : null

		return {
        project_id: article.project_id ?? article.quote_request?.project_id,
        team_name: article.team_name ?? article.quote_request?.team_name,

        article_id: article.article_id ?? article.article?.id,

        quote_request: quoteRequest,
        quote_request_item_id: article.quote_request_item_id ?? null,
        quote_request_items: article.quote_request_items ?? null,

        required_project_item_id:
            article.required_project_item_id ??
            article.required_project_items_id ??
            article.required_project_item?.id ??
            null,

        catalog_number: article.catalog_number ?? article.article?.catalog_number,
        model: article.model ?? article.article?.model,

        supplier: article.supplier,
order_lists_item_id: article.id,
        quantity_required: Number(article.quantity_required),

        delivery_date_deadline:
            article.delivery_date_deadline ??
            this.parseDueDateToInputFormat(this.defaultDueDate()),

        producer_short_name: article.article?.producer?.short_name ?? null,
        producer_id: article.article?.producer_id ?? null,

        price_netto:  Number(article.price_netto)|| 0,
        rabate:
            Number(article.rabate) ||
            Number(article.article?.rabate) ||
            0,

        vat: article.vat ?? article.article?.vat ?? 23,
        currency: article.currency ?? 'PLN',
        comments: article.comments ?? '',
    }
}),
      })

      this.isReady = true
	  
if (this.form.articles.length) {
    this.globalCurrency = this.form.articles[0].currency;
}

      this.applyGlobalRabate()
      this.applyGlobalCurrency()
      this.loadReservations()
	  this.$nextTick(() => {
	  const formatted = this.parseDueDateToInputFormat(this.form.dueDate)

	  this.form.articles.forEach(article => {
		if (!article.delivery_date_deadline) {
		  article.delivery_date_deadline = formatted
		}
	  })
	})
    },
  },
},


  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
		  this.$refs.modalEle.addEventListener('hidden.bs.modal', () => {
    this.$emit('clear-selection');
  });
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    })
    this.suppliersEmails = this.getSuppliersEmails();
  },
  methods: {

mergeComments(items) {
  const comments = items
    .map(item => item.comments)
    .filter(comment => comment && comment.trim())
    .map(comment => comment.trim());

  return [...new Set(comments)].join(' | ');
},

  getTotalNetto() {
  if (!Array.isArray(this.form.articles)) {
    return 0;
  }

  return this.form.articles.reduce((sum, article) => {
    const price = Number(article.price_netto) || 0;
    const qty = Number(article.quantity_required) || 0;
    const rabate = Number(article.rabate) || 0;

    return sum + (price * qty * (1 - rabate / 100));
  }, 0);
},
  setEmailCustomer(key, item) {
  // this.form.emails[key].to = item.value;
    this.form.emails[key].customer_id = item.customer_id;
},
  parseDueDateToInputFormat(dateStr) {
  if (!dateStr) return null
  const [day, month, year] = dateStr.split('.')
  return `${year}-${month}-${day}`
},
normalizeEmail(value) {
  if (!value) return null

  if (typeof value === 'object') {
    value = value.value || value.email || value.label
  }

  if (typeof value !== 'string') return null

  return value.trim().toLowerCase()
},

safeDw(value) {
  if (!Array.isArray(value)) return []

  return value
    .map(v => {
      if (!v) return null
      if (typeof v === 'object') return v.value || v.email || v.label
      return v
    })
    .filter(v => typeof v === 'string' && v.includes('@'))
},
addManualDwEmail(key, event) {
  const raw = event.target.value.trim()
  const value = this.normalizeEmail(raw)

  if (!value || !value.includes('@')) return

  if (!Array.isArray(this.form.emails[key].dw)) {
    this.form.emails[key].dw = []
  }

  const cleanList = this.form.emails[key].dw
    .map(v => this.normalizeEmail(v))
    .filter(Boolean)

  if (!cleanList.includes(value)) {
    cleanList.push(value)
  }

  this.form.emails[key].dw = cleanList

  event.target.value = ''
},

removeDwEmail(key, index) {
  if (!Array.isArray(this.form.emails[key].dw)) {
    this.form.emails[key].dw = []
    return
  }

  this.form.emails[key].dw = this.form.emails[key].dw.filter((_, i) => i !== index)
},

    defaultDueDate() {
      const today = new Date();
      const nextWeek = new Date(today);
      nextWeek.setDate(today.getDate() + 7);
      const year = nextWeek.getFullYear();
      const month = String(nextWeek.getMonth() + 1).padStart(2, '0'); // Miesiąc jest 0-indeksowany
      const day = String(nextWeek.getDate()).padStart(2, '0');

      return `${day}.${month}.${year}`;
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Miesiące w JS są od 0
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },

    changeDeliveryDate(date) {
      this.form.dueDate = date.value;

      // Nadpisz datę dla wszystkich artykułów
      const formatted = this.formatDate(date.value);
      this.form.articles.forEach(article => {
        article.delivery_date_deadline = formatted;
      });
    },

    applyGlobalRabate() {
      this.form.articles.forEach(article => {
        article.rabate = this.globalRabate;
      });
    },

    applyGlobalCurrency() {
      this.form.articles.forEach(article => {
        article.currency = this.globalCurrency;
      });
    },

    prepareSuppliersEmails(items) {
      const suppliersEmails = []
      const seenEmails = new Set()

      items.forEach((item) => {
        const email = item.supplier?.customers_data?.email

        if (
            item.supplier &&
            Object.keys(item.supplier).length > 0 &&
            email &&
            !seenEmails.has(email)
        ) {
          seenEmails.add(email)
          suppliersEmails.push({
            to: '',
            dw: []
          })
        }
      })

      // Jeśli `suppliersEmails` jest pusty, dodaj domyślny obiekt
      if (suppliersEmails.length === 0) {
        suppliersEmails.push({
          to: '',
          dw: []
        })
      }

      return suppliersEmails
    },

    changeComment(event) {
      this.form.comment = event;
    },

    async getSuppliersEmails() {
      const suppliers = await axios.get(route('suppliers.get-all-suppliers'));
      this.suppliersList = suppliers.data;
    },

    async getPaymentMethods() {
      const methods = await axios.get(route('paymentMethods.getAll'));
      this.paymentMethods = methods.data;
    },

saveOrder() {

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  this.form.emails = this.form.emails.map(e => {

    const normalize = (v) => {
      if (!v) return null
      if (typeof v === 'object') v = v.value || v.email || v.label
      if (typeof v !== 'string') return null
      return v.trim().toLowerCase()
    }

    const to = normalize(e.to)

    const dw = (Array.isArray(e.dw) ? e.dw : [e.dw])
      .map(normalize)
      .filter(v => emailRegex.test(v))

    return {
      ...e,
      to,
      dw
    }
  })

  this.form.post(route('orderLists.storeFromOrder'), {
    onSuccess: () => {
      this.$emit('added-success', 'Zamówienie zostało utworzone.')
	  this.$emit('clear-selection');
      this.hide()
    },
    onError: (errors) => {
      console.log('errors:', errors)
      this.errors = errors
      let errorMessages = Object.values(errors).flat().join(', ')
      this.$emit('added-error', 'Błąd podczas tworzenia zamówienia: ' + errorMessages)
    }
  })
},
/*
    async loadReservations() {
      for (const article of this.form.articles) {
        try {
          const response = await axios.get(route('warehouse.check-article-reservation', {
    article: article.article_id,
    required_project_item_id: article.required_project_item_id,
    reserving: 0
}));

          const key = `${article.article_id}-${article.required_project_item_id}`;
          this.reservations[key] = response.data;

        } catch (error) {
          console.error(error);
        }
      }
    },
*/
async loadReservations() {
  for (const article of this.form.articles ?? []) {

if (!article?.article_id || !article?.required_project_item_id) {
    continue;
}

    try {
      const response = await axios.get(route('warehouse.check-article-reservation', {
        article: article.article_id,
        required_project_item_id: article.required_project_item_id,
        reserving: 0
      }));

      const key = `${article.article_id}-${article.required_project_item_id}`;
      this.reservations[key] = response.data;

    } catch (error) {
      console.error(error);
    }
  }
},

    removeArticle(idx) {
      this.form.articles.splice(idx, 1);
    },

    hasError(field) {
      const error = this.errors && this.errors[field];
      return error;
    },

    getErrorMessage(field) {
      if (!this.errors[field]) {
        return '';
      }

      if (/^Pole .*? jest wymagane\.$/.test(this.errors[field])) {
        return 'To pole jest wymagane.';
      }

      return 'To pole ma niepoprawną wartość';
    },

    show() {
      if (this.modalObj) {

        // aktualizuj przy otwarciu modala globalne wartości
        this.globalRabate = 0;
        this.globalCurrency = 'PLN';

        this.applyGlobalRabate();
        this.applyGlobalCurrency();

        this.modalObj.show();
      }
    },
    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
  }
}
</script>


<style scoped>
.widthFirstTd {
  width: 150px;
}

.order-list-table:not(:first-child) {
  border-top: 2px solid #222;
}

.reservation-approved {
  color: #1abc9c !important;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
}

.reservation-notapproved {
  color: #e7515a !important;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
}

/* Kompaktowy wygląd tabel z artykułami */
.table.order-list-table {
  font-size: 13px;
  margin-bottom: 0.75rem;
}

.table.order-list-table td,
.table.order-list-table th {
  padding: 4px 6px !important;
  vertical-align: middle !important;
}

.table.order-list-table input.form-control-sm,
.table.order-list-table select.form-select-sm {
  padding: 2px 6px;
  height: 28px;
  font-size: 13px;
}

.table.order-list-table .widthFirstTd {
  width: 140px;
  font-weight: 500;
  color: #444;
}

/* 🔹 Delikatne oddzielenie sekcji między artykułami */
.order-list-table:not(:first-child) {
  border-top: 1px solid #bbb;
  margin-top: 6px;
  padding-top: 4px;
}

/* 🔹 Kompaktowe tytuły i tooltipy */
h6, .font-weight-bolder {
  font-size: 13px;
}

.reservation-approved,
.reservation-notapproved {
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 12px;
}

.btn.btn-sm.btn-outline-danger {
  padding: 2px 6px;
  font-size: 12px;
  line-height: 1;
}
</style>